import { QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { SessionProvider } from "@/features/auth/session";
import { useIsDesktop } from "@/lib/useMediaQuery";
import { ThemeProvider } from "@/lib/theme";
import { createQueryClient } from "./queryClient";
import { RuntimeProvider } from "./runtime";
import { DEFAULT_SHELL_DATA, ShellDataProvider } from "./shell/shellData";

function AppToaster() {
  const isDesktop = useIsDesktop();
  // Desktop toasts sit above the sticky page action bars so they never cover Next/Start.
  return (
    <Toaster
      position={isDesktop ? "bottom-right" : "top-center"}
      offset={isDesktop ? { bottom: 88, right: 24 } : undefined}
      visibleToasts={3}
      closeButton
    />
  );
}

export function AppProviders({ children, probeRuntime = true }: { children: ReactNode; probeRuntime?: boolean }) {
  const [client] = useState(() => createQueryClient());
  return (
    <QueryClientProvider client={client}>
      <ThemeProvider>
        <TooltipProvider delayDuration={300}>
          <SessionProvider>
            <RuntimeProvider probe={probeRuntime}>
              <ShellDataProvider value={DEFAULT_SHELL_DATA}>
                {children}
                <AppToaster />
              </ShellDataProvider>
            </RuntimeProvider>
          </SessionProvider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
